export const whyZapierLink = {
    href: null,
    text: 'Product',
    submenu: [
        {
            href: '/how-it-works',
            text: 'How it works',
        },
        {
            href: '/features',
            text: 'Features',
        },
        {
            href: '/customers',
            text: 'Customer stories',
        },
        {
            href: '/security',
            text: 'Security',
        },
    ],
};
export const exploreLink = {
    href: null,
    text: 'Explore',
    submenu: [
        {
            href: '/explore',
            text: 'Popular ways to use Zapier',
        },
        {
            href: '/apps',
            text: 'Apps that work with Zapier',
        },
        {
            href: '/roles',
            text: 'Explore Zapier by job role',
        },
    ],
};
export const resourcesLink = {
    href: null,
    text: 'Resources',
    submenu: [
        {
            href: '/blog/',
            text: 'Blog',
            description: 'Read the Zapier blog for tips on productivity, automation, and growing your business',
        },
        {
            href: '/experts',
            text: 'Experts',
            description: 'Hire a Zapier Expert to help you improve processes and automate workflows.',
        },
        {
            href: '/help',
            text: 'Help Center',
            description: 'Get help with Zapier from our tutorials, FAQs, and troubleshooting articles.',
        },
        {
            href: 'https://community.zapier.com',
            text: 'Community',
            description: 'Ask questions, share your knowledge, and get inspired by other Zapier users.',
        },
        {
            href: '/university',
            text: 'Zapier University',
            description: 'Video courses designed to help you become a better Zapier user.',
        },
        {
            href: 'https://go.zapier.com/webinars-on-demand/',
            text: 'Webinars',
            description: 'Learn about automation anytime, anywhere with our on-demand webinar library.',
        },
    ],
};
export const teamsLink = {
    href: '/teams-companies',
    text: 'Teams & Companies',
};
export const pricingLink = {
    href: '/pricing',
    text: 'Pricing',
};
export const dashboardLink = {
    href: '/app/dashboard',
    icon: 'navDashboard',
    text: 'Dashboard',
};
export const zapsLink = {
    href: '/app/zaps',
    icon: 'miscBoltAlt',
    text: 'Zaps',
};
export const myAppsLink = {
    href: '/app/connections',
    icon: 'navApps',
    text: 'My Apps',
};
export const historyLink = {
    href: '/app/history/usage',
    icon: 'miscClock',
    text: 'Zap History',
};
export const exploreLinkInternal = {
    href: '/explore',
    icon: 'navExplore',
    text: 'Explore',
};
export const helpLink = {
    href: '/help',
    icon: 'navHelp',
    isExternal: true,
    text: 'Get Help',
};
export const usageLink = {
    href: '/app/settings/billing',
    icon: 'miscWallet',
    text: 'Usage',
};
export const transferLink = {
    href: '/app/transfers',
    icon: 'arrowConnect',
    text: 'Transfers',
};
export const moveZapsLink = {
    href: '/app/move-zaps/',
    icon: 'arrowBigRight',
    text: 'Move Zaps',
};
export const settingsLink = {
    href: '/app/settings/profile',
    icon: 'navCog',
    text: 'Settings',
};
export const logOutLink = {
    href: '/logout',
    icon: 'arrowExit',
    text: 'Log Out',
};
export const UniversalSidebarLinks = (sideNavData) => [
    dashboardLink,
    zapsLink,
    transferLink,
    ...sideNavData,
    myAppsLink,
    historyLink,
    exploreLinkInternal,
    helpLink,
];
export const UniversalTopbarLinks = [
    whyZapierLink,
    exploreLink,
    resourcesLink,
    teamsLink,
    pricingLink,
];
export const AccountsMenuLinks = [
    settingsLink,
    logOutLink,
];
//# sourceMappingURL=links.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
